var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form",
    { on: { submit: _vm.onSubmit } },
    [
      _c("b-form-file", {
        attrs: {
          state: Boolean(_vm.form.list),
          placeholder: "Choisissez un fichier ou déposez-le ici...",
          "drop-placeholder": "Déposez-le ici...",
          accept: ".csv, .xls, .xlsx",
        },
        model: {
          value: _vm.form.list,
          callback: function ($$v) {
            _vm.$set(_vm.form, "list", $$v)
          },
          expression: "form.list",
        },
      }),
      _vm._v(" "),
      _vm.form.list
        ? _c("div", { staticClass: "mt-3" }, [
            _vm._v(
              "Fichier sélectionné: " +
                _vm._s(_vm.form.list ? _vm.form.list.name : "")
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticClass: "ani-flex-auto",
          attrs: {
            disabled: _vm.buttonDisabled,
            type: "submit",
            variant: "success",
          },
        },
        [_vm._v("Importer")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }